/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import { pkg } from '../../../settings';
var blockClass = "".concat(pkg.prefix, "--datagrid"); // eslint-disable-next-line react/prop-types

var DatagridExpandedRow = function DatagridExpandedRow(PreviousRowRenderer, ExpandedRowContentComponent) {
  return function (datagridState) {
    var row = datagridState.row;

    var _ref = row || {},
        expandedContentHeight = _ref.expandedContentHeight;

    if (!row.isExpanded) {
      return PreviousRowRenderer(datagridState);
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(blockClass, "__expanded-row")
    }, PreviousRowRenderer(datagridState), /*#__PURE__*/React.createElement("div", {
      className: "".concat(blockClass, "__expanded-row-content"),
      style: {
        height: expandedContentHeight ? expandedContentHeight : null
      }
    }, ExpandedRowContentComponent(datagridState)));
  };
};

export default DatagridExpandedRow;